// extracted by mini-css-extract-plugin
export default {"pagination-controls":"pageChange_pagination-controls__8Mqgp","pagination-button":"pageChange_pagination-button__nHhtN","current-page":"pageChange_current-page__eqktl"};